import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import Logo from './Logo';
import './Navbar.css';

const Navbar = ({ t, lang, setLang, scrollToSection }) => {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!isHomePage) return;

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const sections = ['home', 'services', 'about', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  const handleNavClick = (e, sectionId) => {
    if (!isHomePage) return;
    e.preventDefault();
    scrollToSection(sectionId);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        {isHomePage ? (
          <a href="#home" className="logo" onClick={(e) => handleNavClick(e, 'home')}>
            <Logo className="nav-logo" />
            <div className="logo-text">
              Arma<span>Rayan</span>
            </div>
          </a>
        ) : (
          <Link to="/" className="logo">
            <Logo className="nav-logo" />
            <div className="logo-text">
              Arma<span>Rayan</span>
            </div>
          </Link>
        )}

        <ul className="nav-links">
          {['home', 'services', 'about', 'contact'].map((section) => (
            <li key={section}>
              {isHomePage ? (
                <a
                  href={`#${section}`}
                  className={activeSection === section ? 'active' : ''}
                  onClick={(e) => handleNavClick(e, section)}
                >
                  {t.nav[section]}
                </a>
              ) : (
                <Link
                  to={`/#${section}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {t.nav[section]}
                </Link>
              )}
            </li>
          ))}
        </ul>

        <div className="nav-right">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          <div className="lang-switch">
            <button
              className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </button>
            <button
              className={`lang-btn ${lang === 'fa' ? 'active' : ''}`}
              onClick={() => setLang('fa')}
            >
              فا
            </button>
          </div>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        {['home', 'services', 'about', 'contact'].map((section) => (
          isHomePage ? (
            <a key={section} href={`#${section}`} onClick={(e) => handleNavClick(e, section)}>
              {t.nav[section]}
            </a>
          ) : (
            <Link key={section} to={`/#${section}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav[section]}
            </Link>
          )
        ))}
      </div>
    </>
  );
};

export default Navbar;
